import { render, staticRenderFns } from "./ReceiptList.vue?vue&type=template&id=26a287d4&scoped=true"
import script from "./ReceiptList.vue?vue&type=script&lang=ts"
export * from "./ReceiptList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a287d4",
  null
  
)

export default component.exports